import React from 'react';
import { Box, IconButton } from '@mui/joy';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const StarRating = ({ 
  value = 0, 
  onChange, 
  size = 'medium',
  readOnly = false,
  label = 'Оценка',
  maxStars = 5 
}) => {
  const sizes = {
    small: { icon: '20px', gap: '4px' },
    medium: { icon: '28px', gap: '6px' },
    large: { icon: '36px', gap: '8px' }
  };

  const currentSize = sizes[size] || sizes.medium;

  const handleStarClick = (starValue) => {
    if (!readOnly && onChange) {
      onChange(starValue);
    }
  };

  const handleStarHover = (starValue) => {
    if (!readOnly) {
      // Можно добавить эффект при наведении если нужно
    }
  };

  return (
    <Box role="group" aria-label={label}
      sx={{ 
        display: 'flex', 
        gap: currentSize.gap,
        alignItems: 'center'
      }}
    >
      {[...Array(maxStars)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= value;
        
        return (
          <IconButton
            key={starValue}
            aria-label={`${label}: ${starValue} из ${maxStars}`}
            aria-pressed={starValue === value}
            onClick={() => handleStarClick(starValue)}
            onMouseEnter={() => handleStarHover(starValue)}
            disabled={readOnly}
            variant="plain"
            sx={{
              padding: 0,
              '&:hover': !readOnly ? {
                transform: 'scale(1.1)',
                transition: 'transform 0.2s'
              } : {},
              '&:disabled': {
                cursor: 'default'
              }
            }}
          >
            {isFilled ? (
              <StarIcon 
                sx={{ 
                  fontSize: currentSize.icon,
                  color: '#FFD700', // Золотой цвет для заполненных звезд
                  filter: 'drop-shadow(0 0 2px rgba(255, 215, 0, 0.5))'
                }} 
              />
            ) : (
              <StarBorderIcon 
                sx={{ 
                  fontSize: currentSize.icon,
                  color: readOnly ? '#e0e0e0' : '#ffd700', // Серый для readOnly, золотой для активных
                  opacity: readOnly ? 0.5 : 0.7
                }} 
              />
            )}
          </IconButton>
        );
      })}
    </Box>
  );
};

export default StarRating;